import NextLink from 'next/link';
import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

import type { JSX } from 'react';
import type { LinkProps } from 'next/link';
import type { IconProp } from 'components/common/icons/Icon';

export type LinkInterface = LinkProps & {
  className?: string;
  external?: boolean;
  href: string | LinkProps['href'];
  icon?: IconProp;
  linkColor?: string;
  onClick?: (ev?: React.MouseEvent) => void;
  openInNewTab?: boolean;
  openInNewTabIcon?: boolean;
  style?: React.CSSProperties;
} & (
    | { children?: never; text?: string | JSX.Element }
    | { children: React.ReactNode; text?: never }
  );

const Link = ({
  as,
  children,
  className,
  external,
  href,
  icon,
  linkColor,
  onClick,
  openInNewTab,
  openInNewTabIcon = true,
  prefetch,
  style,
  text
}: LinkInterface) => {
  const { theme } = useReduxState();

  const iconContent = icon ? (
    <span className="icon">
      <Icon
        icon={icon}
        style={{ fontSize: '0.9em', marginRight: text ? 5 : 0 }}
      />
    </span>
  ) : null;

  const linkAttrs = prefetch ? { prefetch } : {};

  return (
    <NextLink
      as={as}
      className={`vuo-common-link ${className || ''}`}
      href={href}
      onClick={onClick}
      style={style}
      {...linkAttrs}
      {...(external && openInNewTab
        ? { target: '_blank', rel: 'noopener noreferrer' }
        : {})}
    >
      {children ? (
        children
      ) : (
        <>
          {iconContent}
          {text}

          {openInNewTab && openInNewTabIcon ? (
            <span>
              {' '}
              <Icon icon="external-link-alt" style={{ fontSize: '0.8em' }} />
            </span>
          ) : null}
        </>
      )}

      <style jsx global>{`
        .vuo-common-link {
          color: ${linkColor || theme.linkColor};
          font-weight: 600;
          text-decoration: none;
        }
        .vuo-common-link:hover,
        .vuo-common-link:focus {
          text-decoration: underline;
        }
      `}</style>
    </NextLink>
  );
};

export default Link;
